import React, { useRef, Fragment } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { TrustBadges } from './TrustBadges';
import { useOfferTimer } from '../hooks/useOfferTimer';
export function BookExcerpts() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const {
    isExpired
  } = useOfferTimer();
  return <section ref={ref} className="w-full bg-[#0a0a0a] py-14 md:py-28 px-6" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-34">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-35">
            Fragmentos del libro
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-36">
            Palabras que no se olvidan
          </h2>
          <div className="gold-divider" data-id="element-37" />
        </motion.div>

        <div className="space-y-12" data-id="element-38">
          {/* Excerpt 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="relative pl-8 border-l-2 border-[#C0392B]" data-id="element-39">
            <blockquote className="text-2xl md:text-3xl text-[#E8D5B0] leading-relaxed mb-4" data-id="element-40">
              "No fue la pobreza lo que nos rompió. Fue ver cómo la esperanza se
              apagaba en los ojos de quienes más amábamos."
            </blockquote>
            <cite className="text-[#9A9080] text-sm font-['Lato'] not-italic" data-id="element-41">
              — Capítulo III: El año en que todo cambió
            </cite>
          </motion.div>

          {/* Excerpt 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative pl-8 border-l-2 border-[#CF9B2E]" data-id="element-42">
            <blockquote className="text-2xl md:text-3xl text-[#E8D5B0] leading-relaxed mb-4" data-id="element-43">
              "Venezuela no murió. La enterraron viva. Y desde adentro del
              ataúd, su gente siguió gritando."
            </blockquote>
            <cite className="text-[#9A9080] text-sm font-['Lato'] not-italic" data-id="element-44">
              — Prólogo
            </cite>
          </motion.div>

          {/* Excerpt 3 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="relative pl-8 border-l-2 border-[#1A5276]" data-id="element-45">
            <blockquote className="text-2xl md:text-3xl text-[#E8D5B0] leading-relaxed mb-4" data-id="element-46">
              "El exilio no es solo un lugar. Es una herida que sangra en
              silencio cada vez que alguien te pregunta de dónde eres."
            </blockquote>
            <cite className="text-[#9A9080] text-sm font-['Lato'] not-italic" data-id="element-47">
              — Capítulo VII: Los que se fueron
            </cite>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.8
      }} className="mt-16 text-center" data-id="element-48">
          <a href="https://templeofpages.com/es/cart/48590206533875:1" className="btn-primary inline-block w-full max-w-md px-10 py-6 text-base md:text-lg rounded-sm font-black tracking-wider" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart', {
              content_name: 'Venezuela — La verdad que el mundo no quiso ver',
              content_type: 'product',
              value: isExpired ? 27.99 : 13.99,
              currency: 'USD'
            });
          }
        }} data-id="element-49">
            {'LEER EL LIBRO COMPLETO \u2014 13.99 USD'}
          </a>
          <TrustBadges data-id="element-50" />
        </motion.div>
      </div>
    </section>;
}